export const drawMode = {
  TRIANGLES      : 0,
  LINES          : 1,
  TRIANGLE_STRIP : 2,
  TRIANGLE_FAN   : 3,
  POINTS         : 4,
};
export const attributeId = {
  POSITION   : 1,
  INDICES_32 : 2,
  INDICES_16 : 6,
  INDICES_8  : 7,
  NORMAL     : 3,
  UV         : 4,
  COLOR      : 5,
  SIZE       : 8,
  POSITION2D : 9,
  FIT_MASK   : 10,
  DISTANCE   : 11,
  EDGES_INDICES_32: 12,
  EDGES_INDICES_16: 13,
  EDGES_INDICES_8 : 14,
  OLD_INDICES: 16,
};
export const primitiveType = {
  PLANE       : 0,
  SPHERE      : 1,
  AABOX       : 2,
  SCREEN_QUAD : 3,
  CIRCLE      : 4,
  LINE        : 5,
  GRID        : 6,
  LINE_ARRAY  : 7,
  TEXT_PLANE  : 8,
  ARROW       : 9,
};
export const triangleSide = {
  FRONT : 0,
  BACK : 1,
  FRONT_AND_BACK : 2
};
export const stencilFunc = {
  NEVER : 0,
  LESS : 1,
  EQUAL : 2,
  LEQUAL : 3,
  GREATER : 4,
  NOTEQUAL : 5,
  GEQUAL : 6,
  ALWAYS : 7
};
export const stencilAction = {
  KEEP : 0,
  ZERO : 1,
  REPLACE : 2,
  INCR : 3,
  INCR_WRAP : 4,
  DECR : 5,
  DECR_WRAP : 6,
  INVERT : 7
};
export const stencilValue = {
  HIGHLIGHTED_OBJECT: 1,
  TRANSPARENT_LINES: 2,
  OPAQUE_LINES: 3,
  DEFAULT_BORDER: 4,
  HOVERED_BORDER: 5,
  ACTIVE_BORDER: 6,
  CLEAR: 127,
};
export const pixelBufferType = {
  T_RGBA      : 0,
  T_DEPTH     : 1,
  RB_DEPTH    : 2,
  RB_RGBA     : 3,
  RB_STENCIL  : 4,
  T_RGBA16F   : 5,
  T_RG32F     : 6,
  T_COMPRESSED: 7,
  CM_RGBA     : 8,
};
export const attachmentId = {
  BASE_COLOR_TEXTURE: 0,
  OUTPUT_COLOR_TEXTURE: 1,
  TRIANGLE_ID_TEXTURE: 2,
  WORKSPACE_DEPTH_STENCIL: 3,
  INTERFACE_DEPTH: 4,
  OBJECT_ID_TEXTURE: 5,
  COMPARE_LEFT_TEXTURE: 6,
  COMPARE_RIGHT_TEXTURE: 7,
  COMPARE_LEFT_TRIANGLE_ID_TEXTURE: 8,
  COMPARE_RIGHT_TRIANGLE_ID_TEXTURE: 9,
};
export const geometry = {
  AXIS_X : new Float32Array([1, 0, 0]),
  AXIS_MX : new Float32Array([-1, 0, 0]),
  AXIS_Y : new Float32Array([0, 1, 0]),
  AXIS_MY : new Float32Array([0, -1, 0]),
  AXIS_Z : new Float32Array([0, 0, 1]),
  AXIS_MZ : new Float32Array([0, 0, -1])
};
export const vboType = {
  FLOAT: 0,
  UNSIGNED_BYTE : 1
};
export const bufferType = {
  F32_1  : 0,
  F32_2  : 1,
  F32_3  : 2,
  F32_4  : 3,
  UI8_1  : 4,
  UI8_2  : 5,
  UI8_3  : 6,
  UI8_4  : 7,
  UI16_1 : 8,
  UI16_2 : 9,
  UI16_3 : 10,
  UI32_1 : 11,
  UI32_2 : 12,
  UI32_3 : 13,
  I8_1   : 14,
  I8_2   : 15,
  I8_3   : 16,
  I16_1  : 17,
  I16_2  : 18,
  I16_3  : 19,
  I32_1  : 20,
  I32_2  : 21,
  I32_3  : 22,
};
export const objectType = {
  BBOX    : 0,
  MESH    : 1
};
export const blendFactor = {
  ZERO                     : 0,
  ONE                      : 1,
  SRC_ALPHA                : 2,
  ONE_MINUS_SRC_ALPHA      : 3,
  DST_ALPHA                : 4,
  ONE_MINUS_DST_ALPHA      : 5,
  CONSTANT_ALPHA           : 6,
  ONE_MINUS_CONSTANT_ALPHA : 7,
  SRC_COLOR                : 8,
  ONE_MINUS_SRC_COLOR      : 9,
  DST_COLOR                : 10,
  ONE_MINUS_DST_COLOR      : 11
};
export const blendEquation = {
  FUNC_ADD              : 0,
  FUNC_SUBTRACT         : 1,
  FUNC_REVERSE_SUBTRACT : 2,
  MIN                   : 3,
  MAX                   : 4
};
export const textureMagFilter = {
  NEAREST : 0,
  LINEAR  : 1
};
export const textureMinFilter = {
  NEAREST                : 0,
  LINEAR                 : 1,
  NEAREST_MIPMAP_NEAREST : 2,
  LINEAR_MIPMAP_NEAREST  : 3,
  NEAREST_MIPMAP_LINEAR  : 4,
  LINEAR_MIPMAP_LINEAR   : 5
};
export const textureWrapper = {
  CLAMP  : 0,
  REPEAT : 1,
  MIRROR : 2
};
export const RBIntFormat = {
  R4G4B4A4: 0,
  R5G6B5  : 1,
  R5G5B5A1: 2,
  R8G8B8A8: 3,
  D16U    : 4,
  D24U    : 5,
  S8      : 6,
  DS      : 7,
  D24S8   : 8,
};
export const CompressedTextureFormat = {
  DXT1  : 0,
  DXT3  : 1,
  DXT5  : 2,
};
export const direction = {
  RIGHT: 1,
  LEFT: -1,
  UP: 1,
  DOWN: -1,
  FORWARD: 1,
  BACKWARD: -1,
  NONE: 0
};
export const cameraType = {
  PERSPECTIVE : 0,
  ORTHO       : 1
};
export const easingType = {
  LINEAR         : 0,
  IN_QUAD        : 1,
  OUT_QUAD       : 2,
  IN_OUT_QUAD    : 3,
  IN_CUBIC       : 4,
  OUT_CUBIC      : 5,
  IN_OUT_CUBIC   : 6,
  IN_QUART       : 7,
  OUT_QUART      : 8,
  IN_OUT_QUART   : 9,
  IN_QUINT       : 10,
  OUT_QUINT      : 11,
  IN_OUT_QUINT   : 12,
  IN_SINE        : 13,
  OUT_SINE       : 14,
  IN_OUT_SINE    : 15,
  IN_EXPO        : 16,
  OUT_EXPO       : 17,
  IN_OUT_EXPO    : 18,
  IN_CIRC        : 19,
  OUT_CIRC       : 20,
  IN_OUT_CIRC    : 21,
  IN_ELASTIC     : 22,
  OUT_ELASTIC    : 23,
  IN_OUT_ELASTIC : 24,
  IN_BACK        : 25,
  OUT_BACK       : 26,
  IN_OUT_BACK    : 27,
  IN_BOUNCE      : 28,
  OUT_BOUNCE     : 29,
  IN_OUT_BOUNCE  : 30
};

export const uniformType = {
  FLOAT1:  0,
  FLOAT1V: 1,
  FLOAT2:  2,
  FLOAT2V: 3,
  FLOAT3:  4,
  FLOAT3V: 5,
  FLOAT4:  6,
  FLOAT4V: 7,

  INT1:    8,
  INT1V:   9,
  INT2:   10,
  INT2V:  11,
  INT3:   12,
  INT3V:  13,
  INT4:   14,
  INT4V:  15,

  MAT2:   16,
  MAT3:   17,
  MAT4:   18
};

export const uniformSource = {
  SHADER: 0,
  OBJECT: 1,
  CHUNK:  2,
  SCENE:  3
};

export const drawQueryState = {
  INACTIVE: -1,
  SHOULD_RUN:  0,
  IN_PROGRESS: 1,
  FINISHED:    2
};

export const memoryType = {
  CPU_GEOMETRY: 1,
  GPU_GEOMETRY: 2,
  GPU_TEXTURES: 3,
  GPU_FRAMEBUFFERS: 4,
};

export const cullingFrontFace = {
  CLOCK_WISE:  1,
  COUNTER_CLOCK_WISE: 2,
};

export const cubeMapTarget = {
  POSITIVE_X: 0,
  NEGATIVE_X: 1,
  POSITIVE_Y: 2,
  NEGATIVE_Y: 3,
  POSITIVE_Z: 4,
  NEGATIVE_Z: 5,
}

export const networkStatus = {
  OK    : 0,
  ERROR : 1
};

export const MAX_UINT8_ELEMS = 255;
export const MAX_UINT16_ELEMS = 256 * 256 - 1;
export const MAX_UINT32_ELEMS = 256 * 256 * 256 * 256 - 1;

export const EPSILON = 1E-8;
